<template>
  <v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color" location="bottom right">
    {{ snackbar.message }}
  </v-snackbar>
</template>

<script setup lang="ts">
import { useSnackbarStore } from '@/store/snackbar'
const snackbar = useSnackbarStore()
</script>
